import { createSlice } from "@reduxjs/toolkit";
import { getAllsupportEmails, updateSupportEmails } from "../thunks/supportEmailconfigThunks";

const supportEmailSlice = createSlice({
  name: "supportEmail",
  initialState: {
    supportEmails: {
        emails: {},
    },
     supportLogs: {
      logs: [],
      pagination: {},
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllsupportEmails.fulfilled, (state, action) => {
      state.supportEmails.emails = action.payload.data || null;
    });
    builder.addCase(updateSupportEmails.fulfilled, (state, action) => {
      const { legalSupportEmail, reqMaintenanceEmail, taxConsultEmail } = action.payload.data;   
      state.supportEmails.emails = {
        legalSupportEmail,
        reqMaintenanceEmail,
        taxConsultEmail
      }
    });
  },
});

export default supportEmailSlice.reducer;
